<template>
	<TheHeader></TheHeader>
	
	<div class="container-fluid">
		<div class="container">
			<form name="form">
				<div class="contain row">
					<TheSidebar></TheSidebar>
					
					<ThePageLoading v-if="isPageLoading"></ThePageLoading>
					
					<div class="page-container card col-md-8" v-if="!isPageLoading">
						<ThePageHeader @import-txt-event="(files) => importTemplate(files, 'txt')" @import-excel-event="(files) => importTemplate(files, 'excel')" @export-zip-event="() => showExportTemplateDialog('zip')" @export-excel-event="() => showExportTemplateDialog('excel')" @delete-event="deleteSheet" :key="isImporting && isExporting && isDeleting" :renderImportTemplate="activeIndex == 1" :isImporting="isImporting" :renderExportTemplate="activeIndex == 1" :isExporting="isExporting" :renderDelete="identifier != null && activeIndex == 0" :isDeleting="isDeleting"></ThePageHeader>
						
						<div class="row" v-if="pageError == ''">
							<TabView class="p-1" v-model:activeIndex="activeIndex" @tab-change="onTabChange">
								<TabPanel>
									<template #header>
										<i class="pi pi-fw pi-file"></i>
										<span>Info</span>
									</template>
									
									<TheTabViewLoading v-if="isPageLoading"></TheTabViewLoading>
						
									<div class="row" v-if="!isPageLoading">
										<div class="col-md-12 p-4">
											<div class="row mb-3">
												<div class="col-md-3 required">
													<label class="col-form-label-title">Code:</label>
												</div>
															
												<div class="col-md-6">
													<InputText class="p-inputtext" type="text" maxlength="10" placeholder="Code" v-model="sheet.code" />
												</div>
											</div>
											
											<div class="row mb-3">
												<div class="col-md-3 required">
													<label class="col-form-label-title">Title:</label>
												</div>
															
												<div class="col-md-6">
													<InputText class="p-inputtext" type="text" maxlength="50" placeholder="Title" v-model="sheet.name" />
												</div>
											</div>

											<div class="row mb-3">
												<div class="col-md-3 required">
													<label class="col-form-label-title">Sequence:</label>
												</div>
															
												<div class="col-md-6">
													<InputNumber :min="1" :max="200" v-model="sheet.sequence" :disabled="sheet.type == null || sheet.type == ''"/>
												</div>

												<div class="col-md-3">
													<Button class="p-button-sm" label="Next Sequence" @click="getNextSequence" :disabled="sheet.type == null || sheet.type == ''"/>
												</div>
											</div>
											
											<div class="row mb-3" v-if="identifier != null">
												<div class="col-md-3 required">
													<label class="col-form-label-title">Status:</label>
												</div>
															
												<div class="col-md-6">
													<Dropdown :options="getActiveStatuses(statuses)" optionLabel="name" optionValue="value" placeholder="-- Please Select --" v-model="sheet.isClosed" />
												</div>
											</div>
												
											<div class="row mb-3">
												<div class="col-md-3"></div>
															
												<div class="d-flex col-md-6">
													<Button class="p-button-sm" :disabled="v$.sheet.$invalid || isLoading" @click="identifier == null ? save() : update()" label="Save"/>
													<span class="p-1"></span>
													<Button class="p-button-sm p-button-secondary" @click="cancel" label="Cancel"/>
																
													<TheLoading v-if="isLoading"></TheLoading>
												</div>
											</div>
										</div>
									</div>
								</TabPanel>
								
								<TabPanel v-if="identifier != null">
									<template #header>
										<i class="pi pi-fw pi-book"></i>
										<span>Template</span>
									</template>
									
									<TheTabViewLoading v-if="isPageLoading"></TheTabViewLoading>
						
									<div class="row" v-if="!isPageLoading">
										<div class="row p-3">
											<div class="col-md-5 d-flex align-items-center">
												<Button class="p-button-sm" @click="addTemplate" label="Add" :disabled="pagination.totalItems > 0"/>
												<span class="p-1"></span>
												<!-- <Button class="p-button-sm" @click="revertTemplate" label="Revert" :disabled="pagination == null || pagination.activeVersion == null || pagination.activeVersion == 1"/> -->
											</div>
												
											<div class="col-md-7">
												<Paginator :first="paginator" :pageLinkSize="3" :rows="pagination.itemsPerPage" :totalRecords="pagination.totalItems" @page="find($event.page + 1)" v-if="pagination.currentPage != 0" />
											</div>
										</div>
										
										<div class="row">
											<div class="col-md-12 p-4">
												<table class="p-datatable p-component p-datatable-hoverable-rows align-middle mb-0 w-12">
													<thead class="p-datatable-thead">
														<tr>
															<th style="width: 6%;">#</th>
															<th style="width: 20%; cursor: pointer;" @click="sort('x.createdDate')">Created Date <span class="pi" :class="[sortingModel.columnName == 'x.createdDate' ? (sortingModel.isAscending ? 'pi-sort-amount-up-alt' : 'pi-sort-amount-down') : 'pi-fw pi-sort-alt']"></span></th>
															<th style="width: 22%; cursor: pointer;" @click="sort('x.lastModifiedDate')">Last Modified Date <span class="pi" :class="[sortingModel.columnName == 'x.lastModifiedDate' ? (sortingModel.isAscending ? 'pi-sort-amount-up-alt' : 'pi-sort-amount-down') : 'pi-fw pi-sort-alt']"></span></th>
															<th style="width: 20%; cursor: pointer;" @click="sort('x.publishedDate')">Published Date <span class="pi" :class="[sortingModel.columnName == 'x.publishedDate' ? (sortingModel.isAscending ? 'pi-sort-amount-up-alt' : 'pi-sort-amount-down') : 'pi-fw pi-sort-alt']"></span></th>
															<th style="width: 12%; cursor: pointer;" @click="sort('x.version')">Version <span class="pi" :class="[sortingModel.columnName == 'x.version' ? (sortingModel.isAscending ? 'pi-sort-amount-up-alt' : 'pi-sort-amount-down') : 'pi-fw pi-sort-alt']"></span></th>
															<th style="width: 10%;" class="text-center">Status</th>
															<th style="width: 10%;" class="text-center">Action</th>
														</tr>
													</thead>
													<tbody class="p-datatable-tbody" v-if="!isLoading">
														<tr v-for="(template, index) in pagination.templates" :key="index">
															<td v-on:click="viewTemplate(template)">{{((pagination.currentPage - 1) * pagination.itemsPerPage) + index + 1}}</td>
															<td v-on:click="viewTemplate(template)">{{template.createdDate}}</td>
															<td v-on:click="viewTemplate(template)">{{template.lastModifiedDate}}</td>
															<td v-on:click="viewTemplate(template)">{{template.publishedDate}}</td>
															<td v-on:click="viewTemplate(template)" class="text-center">{{displayTemplateVersion(template)}}</td>
															<td v-on:click="viewTemplate(template)" class="text-center">
																<Badge 
																	class="mr-2" 
																	:class="template.publishedDate == null ? 'p-badge-danger' : template.status == 'Active' ? 'p-badge-success' : 'p-badge-secondary'" 
																	:value="template.publishedDate == null ? 'Draft' : 'Published'" 
																	v-if="template.status != null"
																></Badge>
															</td>
															<td class="text-center">
																<div class="d-flex justify-content-center">
																	<Button icon="pi pi-upload" :title="template.publishedDate == null ? 'Publish' : 'Republish'" severity="warning" text rounded @click="publishTemplate(template)" v-if="template.status != 'Active'" />
																	<Button icon="pi pi-clone" title="Clone (new draft version for all active sheets)" severity="primary" text rounded @click="cloneTemplate(template)" v-if="template.publishedDate != null"/>
																	<Button icon="pi pi-copy" title="Clone this sheet only into an existing draft version" severity="info" text rounded @click="showCloneSingleDialog(template)" v-if="template.publishedDate != null"/>
																	<Button icon="pi pi-minus-circle" title="Delete this draft only (other sheets in the version are kept)" severity="danger" text rounded @click="deleteTemplateSingle(template)" v-if="template.publishedDate == null"/>
																	<Button icon="pi pi-trash" title="Delete all drafts of this version" severity="danger" text rounded @click="deleteTemplate(template)" v-if="template.publishedDate == null"/>
																</div>
															</td>
														</tr>
													</tbody>
												</table>
											</div>
											
											<div class="error-no-record" v-if="!isLoading && pagination.templates.length == 0">
												<FontAwesomeIcon :icon="['fas', 'image']" size="2x" />
												<h6><span>No Record Found</span></h6>
											</div>
											
											<TheTableLoading v-if="isLoading"></TheTableLoading>
										</div>
									</div>
								</TabPanel>
							</TabView>
						</div>
						
						<TheTemplateDialog :sheetType="sheet.type" :identifier="dialog.identifier" :version="dialog.version" :publishedDate="dialog.publishedDate" :status="dialog.status" :header="dialog.header" :headerCode="dialog.headerCode" :visible="dialog.visible" :loading="dialog.loading" @save="saveTemplate" @update="updateTemplate" @cancel="closeDialog"></TheTemplateDialog>
							
						<ThePageError @back-event="cancel" :pageError="pageError" v-if="pageError != ''"></ThePageError>
					</div>
					
					<TheFooter></TheFooter>
				</div>
			</form>
		</div>
	</div>
	
	<Dialog header="Import Preview" v-model:visible="displayModal" :draggable="false" :style="{width: '60vw'}" @hide="closeModal">
		<div class="row">
			<div class="col-md-12 d-flex align-items-center mb-3 mb-md-0 me-md-auto text-decoration-none">
				<span class="fs-5">
					<div class="p-3">
						<pre><label class="col-form-label-title">{{templateContent}}</label></pre>
					</div>
				</span>
			</div>
		</div>
		
		<template #footer>
			<div class="d-flex justify-content-end p-2">
				<TheLoading v-if="isDialogLoading"></TheLoading>
				
				<Button class="p-button-text p-button-sm" label="Cancel" icon="pi pi-times" @click="closeModal" />
				<Button class="p-button-sm" label="Proceed" icon="pi pi-check" @click="proceedImport" autofocus />
			</div>
		</template>
	</Dialog>

	<Dialog header="Template" v-model:visible="exportTemplateDialog.visible" :draggable="false" :style="{width: '60vw'}" @hide="hideExportTemplateDialog">

		<div class="row p-3">
			<div class="col-md-5 d-flex align-items-center">
			</div>
				
			<div class="col-md-7">
				<Paginator :first="paginator" :pageLinkSize="3" :rows="exportTemplateDialog.pagination.itemsPerPage" :totalRecords="exportTemplateDialog.pagination.totalItems" @page="findExportTemplates($event.page + 1)" v-if="exportTemplateDialog.pagination.currentPage != 0" />
			</div>
		</div>

		<div class="row">
			<div class="col-md-12 p-4">
				<table class="p-datatable p-component p-datatable-hoverable-rows align-middle mb-0 w-12">
					<thead class="p-datatable-thead">
						<tr>
							<th style="width: 5%;" class="text-center"></th>
							<th style="width: 7%;">#</th>
							<th style="width: 20%; cursor: pointer;" @click="sort('x.createdDate')">Created Date <span class="pi" :class="[sortingModel.columnName == 'x.createdDate' ? (sortingModel.isAscending ? 'pi-sort-amount-up-alt' : 'pi-sort-amount-down') : 'pi-fw pi-sort-alt']"></span></th>
							<th style="width: 20%; cursor: pointer;" @click="sort('x.lastModifiedDate')">Last Modified Date <span class="pi" :class="[sortingModel.columnName == 'x.lastModifiedDate' ? (sortingModel.isAscending ? 'pi-sort-amount-up-alt' : 'pi-sort-amount-down') : 'pi-fw pi-sort-alt']"></span></th>
							<th style="width: 20%; cursor: pointer;" @click="sort('x.publishedDate')">Published Date <span class="pi" :class="[sortingModel.columnName == 'x.publishedDate' ? (sortingModel.isAscending ? 'pi-sort-amount-up-alt' : 'pi-sort-amount-down') : 'pi-fw pi-sort-alt']"></span></th>
							<th style="width: 14%; cursor: pointer;" @click="sort('x.version')">Version <span class="pi" :class="[sortingModel.columnName == 'x.version' ? (sortingModel.isAscending ? 'pi-sort-amount-up-alt' : 'pi-sort-amount-down') : 'pi-fw pi-sort-alt']"></span></th>
							<th style="width: 14%;" class="text-center">Status</th>
						</tr>
					</thead>
					<tbody class="p-datatable-tbody" v-if="!exportTemplateDialog.isLoading">
						<tr v-for="(template, index) in exportTemplateDialog.pagination.templates" :key="index">
							<td>
								<Checkbox v-model="exportTemplateDialog.selectedTemplates" :value="template.identifier" />
							</td>
							<td>{{((exportTemplateDialog.pagination.currentPage - 1) * exportTemplateDialog.pagination.itemsPerPage) + index + 1}}</td>
							<td>{{template.createdDate}}</td>
							<td>{{template.lastModifiedDate}}</td>
							<td>{{template.publishedDate}}</td>
							<td>{{template.version}}</td>
							<td class="text-center">
								<Badge class="mr-2" :class="template.publishedDate == null ? 'p-badge-danger' : template.status == 'Active' ? 'p-badge-success' : 'p-badge-secondary'"  :value="template.publishedDate == null ? 'Draft' : 'Published'"  v-if="template.status != null"></Badge>
							</td>
						</tr>
					</tbody>
				</table>
			</div>
		</div>

		<div class="error-no-record" v-if="!exportTemplateDialog.isLoading && exportTemplateDialog.pagination.templates.length == 0">
			<FontAwesomeIcon :icon="['fas', 'image']" size="2x" />
			<h6><span>No Record Found</span></h6>
		</div>
		
		<TheTableLoading v-if="exportTemplateDialog.isLoading"></TheTableLoading>

		<template #footer>
			<div class="d-flex justify-content-end p-2">
				<Button class="p-button-text p-button-sm" label="Cancel" icon="pi pi-times" @click="hideExportTemplateDialog" />
				<Button class="p-button-sm" label="Export" icon="pi pi-check" @click="exportTemplate" :disabled="exportTemplateDialog.selectedTemplates.length == 0"/>
			</div>
		</template>
	</Dialog>

	<Dialog :header="'Clone Version ' + (cloneSingleDialog.template ? cloneSingleDialog.template.version : '') + ' Into Draft Version'" v-model:visible="cloneSingleDialog.visible" :draggable="false" :style="{width: '60vw'}" @hide="hideCloneSingleDialog">
		<div class="row">
			<div class="col-md-12 p-4">
				<table class="p-datatable p-component p-datatable-hoverable-rows align-middle mb-0 w-12">
					<thead class="p-datatable-thead">
						<tr>
							<th style="width: 7%;">#</th>
							<th style="width: 22%;">Created Date</th>
							<th style="width: 22%;">Last Modified Date</th>
							<th style="width: 13%;">Version</th>
							<th style="width: 12%;">Sheets</th>
							<th style="width: 24%;" class="text-center">This Sheet</th>
						</tr>
					</thead>
					<tbody class="p-datatable-tbody" v-if="!cloneSingleDialog.isLoading">
						<tr v-for="(row, index) in cloneSingleDialog.versions" :key="row.version"
							:style="{cursor: row.hasSheetDraft ? 'not-allowed' : 'pointer', opacity: row.hasSheetDraft ? 0.5 : 1}"
							:title="row.hasSheetDraft ? 'This sheet already has a draft in this version - delete that draft first' : 'Clone into this draft version'"
							@click="cloneTemplateSingle(row)">
							<td>{{index + 1}}</td>
							<td>{{row.createdDate}}</td>
							<td>{{row.lastModifiedDate}}</td>
							<td>{{displaySetVersion(row)}}</td>
							<td>{{row.sheetCount}}</td>
							<td class="text-center">
								<Badge class="mr-2" :class="row.hasSheetDraft ? 'p-badge-danger' : 'p-badge-secondary'" :value="row.hasSheetDraft ? 'Has Draft' : 'No Draft'"></Badge>
							</td>
						</tr>
					</tbody>
				</table>
			</div>
		</div>

		<div class="error-no-record" v-if="!cloneSingleDialog.isLoading && cloneSingleDialog.versions.length == 0">
			<FontAwesomeIcon :icon="['fas', 'image']" size="2x" />
			<h6><span>No Draft Version Found</span></h6>
		</div>

		<TheTableLoading v-if="cloneSingleDialog.isLoading"></TheTableLoading>

		<template #footer>
			<div class="d-flex justify-content-end p-2">
				<Button class="p-button-text p-button-sm" label="Cancel" icon="pi pi-times" @click="hideCloneSingleDialog" />
			</div>
		</template>
	</Dialog>
</template>

<script lang="ts">
	import { defineComponent } from "vue";
	import { useRoute } from "vue-router";
	import store from "@/store";
	import sheetApi from "@/api/sheet-api";
	import templateApi from "@/api/template-api";
	import statusMixin from "@/mixin/status";
	import sheetTypeMixin from "@/mixin/sheet-type"
	import formulaMixin from "@/mixin/formula";
	
	import TheHeader from "@/components/TheHeader.vue";
	import TheFooter from "@/components/TheFooter.vue";
	import TheSidebar from "@/components/TheSidebar.vue";
	import ThePageHeader from "@/components/ThePageHeader.vue";
	import ThePageLoading from "@/components/ThePageLoading.vue";
	import TheTabViewLoading from "@/components/TheTabViewLoading.vue";
	import TheTableLoading from "@/components/TheTableLoading.vue";
	import TheLoading from "@/components/TheLoading.vue";
	import ThePageError from "@/components/ThePageError.vue";
	import TheTemplateDialog from "@/components/TheTemplateDialog.vue";
	
	import useVuelidate from "@vuelidate/core"
	import { required } from "@vuelidate/validators"
	
	export default defineComponent({
		mixins: [statusMixin, sheetTypeMixin, formulaMixin],
		components: {
			TheHeader,
			TheFooter,
			TheSidebar,
			ThePageHeader,
			ThePageLoading,
			TheTabViewLoading,
			TheTableLoading,
			TheLoading,
			ThePageError,
			TheTemplateDialog,
		},
		data() {
			return {
				pageError: (store.getters.error == undefined ? '' : store.getters.error),
				pagination: {currentPage: 1, itemsPerPage: 10, templates: [], totalItems: 0, activeVersion: 0},
				sortingModel: {columnName: "x.createdDate", isAscending: false},
				filterSheetIdModel: {value: useRoute().params.id},
				identifier: useRoute().params.id,
				sheet: {code: '', name: '', type: '', sequence: null, isClosed: false},
				isPageLoading: false,
				isLoading: false,
				isDialogLoading: false,
				activeIndex: 0,
				isImporting: false,
				isExporting: false,
				isDeleting: false,
				dialog: {identifier: null, publishedDate: null, status: null, version: null, header: '', headerCode: '', visible: false, loading: false},
				template: {identifier: null, publishedDate: null, version: null, sheet: {identifier: useRoute().params.id}, content: null},
				exportTemplateDialog: {fileType: '', selectedTemplates: [] as any[], isLoading: false, visible: false, pagination: {currentPage: 1, itemsPerPage: 10, templates: [], totalItems: 0, activeVersion: 0}},
				cloneSingleDialog: {template: null as any, versions: [] as any[], isLoading: false, visible: false},
				displayModal: false,
				templateContent: '',
				parentURL: '/admin/sheet/',
			}
		},
		computed: {
			paginator() {
				return ((this.pagination.currentPage - 1) * this.pagination.itemsPerPage);
			}
		},
		unmounted: function() {
			window.removeEventListener('keydown', this.detectKeyPress);
		},
		mounted: function() {
			window.addEventListener('keydown', this.detectKeyPress);

			if (this.pageError == '') {
				let sheetType = useRoute().meta.sheetType + "";
				this.parentURL = "/admin/sheet/" + sheetType.toLowerCase();
				if (this.identifier != null) {
					this.isPageLoading = true;
					sheetApi.sheetView(this.identifier)
						.then(response => {
							this.sheet = response.data.sheet;
							this.isPageLoading = false;
						})
						.catch(error => {
							this.pageError = error;
							this.isPageLoading = false;
						})
				} else {
					this.sheet.type = sheetType;
				}
			}
		},
		methods: {
			save() {
				this.isLoading = true;
				sheetApi.sheetSave({
						sheet: this.sheet
					})
					.then(response => {
						store.getters.getCached.page = null;
						this.isLoading = false;
						this.$router.push(this.parentURL);
					})
					.catch(error => {
						this.isLoading = false;
						this.$toast.add({severity: "error", summary: "Error", detail: error, life: 6000});
					})
			},
			update() {
				this.isLoading = true;
				sheetApi.sheetUpdate({
						sheet: this.sheet
					})
					.then(response => {
						this.isLoading = false;
						this.$router.push(this.parentURL);
					})
					.catch(error => {
						this.isLoading = false;
						this.$toast.add({severity: "error", summary: "Error", detail: error, life: 6000});
					})
			},
			deleteSheet() {
				this.$confirm.require({
					header: 'Confirmation',
					message: 'Are you sure want to delete this sheet?',
					icon: 'pi pi-exclamation-triangle',
					accept: () => {
						this.isDeleting = true;
						sheetApi.sheetDelete({
								sheet: this.sheet
							})
							.then((response: any) => {
								store.getters.getCached.page = null;
								this.isDeleting = false;
								this.$toast.add({severity: "success", summary: "Success", detail: response.message, life: 6000});
								this.$router.push(this.parentURL);
							})
							.catch(error => {
								this.isDeleting = false;
								this.$toast.add({severity: "error", summary: "Error", detail: error, life: 6000});
							})
					}
				})
			},
			cancel() {
				this.$router.push(this.parentURL);
			},
			// F10 on the page itself goes back to the sheet listing. The template dialog binds the
			// key for itself while it is open (and unbinds on hide), so this only ever sees the
			// presses that happen behind it.
			detectKeyPress(event: any) {
				if (this.dialog.visible || this.displayModal || this.exportTemplateDialog.visible || this.cloneSingleDialog.visible) {
					return;
				}

				switch (event.key) {
					case 'F10': {
						event.preventDefault();
						this.cancel();
						break;
					}
				}
			},
			onTabChange(event: any) {
				if (event.index == 1) {
					this.find(1);
				}
			},
			sort(columnName: string) {
				if (this.sortingModel.columnName == columnName) {
					this.sortingModel.isAscending = !this.sortingModel.isAscending;
				}
				
				else {
					this.sortingModel.columnName = columnName;
					this.sortingModel.isAscending = true;
				}

				if (this.exportTemplateDialog.visible == true){
					this.findExportTemplates(1);
				} else {
					this.find(1);
				}				
			},
			find(page: number) {
				this.isLoading = true;
				
				templateApi.templateFind({
						paginationModel: {currentPage: page},
						sortingModel: this.sortingModel,
						filterSheetIdModel: this.filterSheetIdModel,
					})
					.then(response => {
						this.pagination = {currentPage: response.data.currentPage, itemsPerPage: response.data.itemsPerPage, templates: response.data.rowSet, totalItems: response.data.totalItems, activeVersion: response.data.activeVersion}
						this.isLoading = false;
					})
					.catch(error => {
						this.isLoading = false;
						this.$toast.add({severity: "error", summary: "Error", detail: error, life: 6000});
					})
			},
			findExportTemplates(page: number) {
				this.exportTemplateDialog.isLoading = true;
				templateApi.templateFind({
						paginationModel: {currentPage: page},
						sortingModel: this.sortingModel,
						filterSheetIdModel: this.filterSheetIdModel,
					})
					.then(response => {
						this.exportTemplateDialog.pagination = {currentPage: response.data.currentPage, itemsPerPage: response.data.itemsPerPage, templates: response.data.rowSet, totalItems: response.data.totalItems, activeVersion: response.data.activeVersion}
						this.exportTemplateDialog.isLoading = false;
					})
					.catch(error => {
						this.exportTemplateDialog.isLoading = false;
						this.$toast.add({severity: "error", summary: "Error", detail: error, life: 6000});
					})
			},
			onTypeChange() {
				this.sheet.sequence = null;
			},
			getNextSequence() {
				sheetApi.sheetNextSequence({}, this.sheet.type)
						.then(response => {
							this.sheet.sequence = response.data;
						})
						.catch(error => {
							this.$toast.add({severity: "error", summary: "Error", detail: error, life: 6000});
						});
			},
			addTemplate() {
				this.dialog.identifier = null;
				this.dialog.header = this.sheet.name;
				this.dialog.headerCode = this.sheet.code;
				this.dialog.visible = true;
				
				document.body.classList.add("dialog-open");
			},
			importTemplate(files: any, fileType: string) {
				this.isImporting = true;
				
				var formData = new FormData();
				formData.append('file', files[0]);
				formData.append('fileType', fileType);

				templateApi.templateImportBySheet(
						this.identifier, 
						formData
					)
					.then(response => {
						this.templateContent = response.data;
						this.displayModal = true;
						this.isImporting = false;
					})
					.catch(error => {
						this.isImporting = false;
						this.$toast.add({severity: "error", summary: "Error", detail: error, life: 6000});
					})
			},
			proceedImport() {
				this.isDialogLoading = true;
				templateApi.templateImportProceedBySheet(
						this.identifier,
						this.templateContent
					)
					.then((response: any) => {
						this.isDialogLoading = false;
						this.closeModal();
						this.$toast.add({severity: "success", summary: "Success", detail: response.message, life: 6000});
						this.find(1);
					})
					.catch(error => {
						this.isDialogLoading = false;
						this.$toast.add({severity: "error", summary: "Error", detail: error, life: 6000});
					})
			},
			closeModal() {
				this.displayModal = false;
			},
			showExportTemplateDialog(fileType: string) {
				this.exportTemplateDialog.visible = true;
				this.exportTemplateDialog.fileType = fileType;
				this.exportTemplateDialog.selectedTemplates = [];
				this.findExportTemplates(1);
			},
			hideExportTemplateDialog() {
				this.exportTemplateDialog.visible = false;
				this.exportTemplateDialog.fileType = '';
				this.exportTemplateDialog.selectedTemplates = [];
			},
			exportTemplate() {
				this.isExporting = true;
				templateApi.templateExportBySheet(this.identifier, {templateIds: this.exportTemplateDialog.selectedTemplates, fileType: this.exportTemplateDialog.fileType})
					.then(response => {
						this.isExporting = false;
						this.hideExportTemplateDialog();
					})
					.catch(error => {
						this.isExporting = false;
						this.$toast.add({severity: "error", summary: "Error", detail: error, life: 6000});
					})
			},
			revertTemplate() {
				this.$confirm.require({
					header: 'Confirmation',
					message: 'Are you sure you want to proceed?',
					icon: 'pi pi-exclamation-triangle',
					accept: () => {
						this.isLoading = true;
						
						templateApi.templateRevertBySheet(this.template.sheet.identifier)
							.then((response: any) => {
								this.$toast.add({severity: "success", summary: "Success", detail: response.message, life: 6000});
								this.find(1);
							})
							.catch(error => {
								this.isLoading = false;
								this.$toast.add({severity: "error", summary: "Error", detail: error, life: 6000});
							})
					}
				});
			},
			viewTemplate(template: any) {
				this.dialog.identifier = template.identifier;
				this.dialog.publishedDate = template.publishedDate;
				this.dialog.status = template.status;
				this.dialog.version = template.version;
				this.dialog.header = this.sheet.name;
				this.dialog.headerCode = this.sheet.code;
				this.dialog.visible = true;
				
				document.body.classList.add("dialog-open");
			},
			// publishTemplate(content: any) {
			// 	this.$confirm.require({
			// 		header: 'Confirmation',
			// 		message: 'Are you sure you want to publish all draft templates of this version?',
			// 		icon: 'pi pi-exclamation-triangle',
			// 		accept: () => {
			// 			this.dialog.loading = true;
			// 			this.template.identifier = this.dialog.identifier;
			// 			this.template.content = content;
			// 			this.template.version = this.dialog.version;
						
			// 			this.setIfValues(content);
				
			// 			templateApi.templatePublish({
			// 					template: this.template
			// 				})
			// 				.then(response => {
			// 					this.dialog.loading = false;
			// 					this.closeDialog();
			// 					this.find(1);
			// 				})
			// 				.catch(error => {
			// 					this.dialog.loading = false;
			// 					this.$toast.add({severity: "error", summary: "Error", detail: error, life: 6000});
			// 				})
			// 			}
			// 	});
			// },
			async publishTemplate(template: any) {
				this.isLoading = true;

				// Publishing a draft version retires nothing any more: every active sheet must have
				// a draft in it, so surface the gap here before the update/publish pair runs.
				if (template.publishedDate == null) {
					try {
						const check: any = await templateApi.templateSetMissingDrafts(this.sheet.type, template.version);
						const missing = (check.data && check.data.sheets) || [];
						if (missing.length > 0) {
							this.isLoading = false;
							this.$toast.add({
								severity: "error", summary: "Cannot publish",
								detail: missing.length + " active " + this.sheet.type + " sheet(s) have no draft template in version " + template.version + ": "
									+ missing.map((s: any) => s.sheetCode).join(", ")
									+ ". Create a draft for each (Sheet Editor or Clone), or close the sheet, then publish again.",
								life: 10000,
							});
							return;
						}
					} catch (error) {
						this.isLoading = false;
						this.$toast.add({severity: "error", summary: "Error", detail: error, life: 6000});
						return;
					}
				}

				templateApi.templateView(template.identifier)
					.then(response => {
						this.template.content = response.data.template.content;
						this.template.identifier = template.identifier;
						this.template.version = template.version;
						this.template.publishedDate = template.publishedDate
						this.setIfValues(template.content);
						
						let r1 = templateApi.templateUpdate({template: this.template});
		
						let r2 = templateApi.templatePublish({template: this.template});
		
						Promise.all([r1, r2])
							.then(([, published]: any[]) => {
								this.isLoading = false;
								this.$toast.add({severity: "success", summary: "Success", detail: published.message, life: 6000});
								this.find(1);
							})
							.catch((error: any) => {
								// The server-side check is the authority; its refusal has to be readable, not logged.
								this.isLoading = false;
								this.$toast.add({severity: "error", summary: "Error", detail: error, life: 10000});
								this.find(1);
							})
					})
					.catch(error => {
								this.isLoading = false;
								this.$toast.add({severity: "error", summary: "Error", detail: error, life: 6000});
					})
			},

			cloneTemplate(template: any) {
				this.isLoading = true;

				this.template.identifier = template.identifier;
				this.template.content = template.content;
				this.template.version = template.version;

				templateApi.templateClone({
						template: this.template
					})
					.then(response => {
						this.isLoading = false;
						this.find(1);
					})
					.catch(error => {
						this.isLoading = false;
						this.$toast.add({severity: "error", summary: "Error", detail: error, life: 6000});
					})
			},
			// cloneTemplate(content: any, affectedSheetContents: any) {
			// 	this.$confirm.require({
			// 		header: 'Confirmation',
			// 		message: 'Are you sure you want to clone this template?',
			// 		icon: 'pi pi-exclamation-triangle',
			// 		accept: () => {
			// 			this.dialog.loading = true;
			// 			this.template.identifier = this.dialog.identifier;
			// 			this.template.content = content;
						
			// 			let r1 = templateApi.templateClone({template: this.template})

			// 			let r2 = [] as any [];
			// 			affectedSheetContents.forEach((affectedSheetContent: any) => {
			// 				r2.push(templateApi.templateClone({template: affectedSheetContent}));
			// 			});

			// 			Promise.all([r1, ...r2])
			// 				.then(() => {
			// 					this.dialog.loading = false;
			// 					this.closeDialog();
			// 					this.find(1);
			// 				})
			// 				.catch(error => {
			// 					this.dialog.loading = false;
			// 					this.$toast.add({severity: "error", summary: "Error", detail: error, life: 6000});
			// 				})
			// 			}
			// 	});
			// },
			saveTemplate(content: any) {
				this.dialog.loading = true;
				
				this.setIfValues(content);
				
				this.template.content = content;
				templateApi.templateSave({
						template: this.template
					})
					.then(response => {
						this.dialog.loading = false;
						this.closeDialog();
						this.find(1);
					})
					.catch(error => {
						this.dialog.loading = false;
						this.$toast.add({severity: "error", summary: "Error", detail: error, life: 6000});
					})
			},
			// updateTemplate(content: any, sheet: any) {
			// 	this.dialog.loading = true;
			// 	this.template.identifier = this.dialog.identifier;
				
			// 	this.setIfValues(content);
				
			// 	var template = JSON.parse(JSON.stringify(this.template));
			// 	if (sheet == null) {
			// 		template.identifier = this.dialog.identifier;
			// 		template.content = content;
			// 		template.version = this.dialog.version;
					
			// 		templateApi.templateUpdate({
			// 				template: template
			// 			})
			// 			.then(response => {
			// 				this.dialog.loading = false;
			// 			})
			// 			.catch(error => {
			// 				this.dialog.loading = false;
			// 				this.$toast.add({severity: "error", summary: "Error", detail: error, life: 6000});
			// 			})
			// 	}
				
			// 	else {
			// 		template.content = content;
			// 		template.identifier = sheet.template.identifier;
			// 		template.sheet.identifier = sheet.identifier;
					
			// 		var cached = {sheetId: this.template.sheet.identifier, templateId: this.template.identifier, template: template};
			// 		templateApi.templateUpdateCached({
			// 				cached: cached
			// 			})
			// 			.then(response => {
			// 				//
			// 			})
			// 			.catch(error => {
			// 				this.dialog.loading = false;
			// 				//
			// 			})
			// 	}
			// },
			updateTemplate(content: any, affectedSheetContents: any, sheet: any) {
				this.dialog.loading = true;
				this.template.identifier = this.dialog.identifier;
				
				this.setIfValues(content);
				
				var template = JSON.parse(JSON.stringify(this.template));
				template.identifier = this.dialog.identifier;
				template.content = content;

				let r1 = templateApi.templateUpdate({template: template})
				let r2 = [] as any [];

				affectedSheetContents.forEach((affectedSheetContent: any) => {
					r2.push(templateApi.templateUpdate({template: affectedSheetContent}));
				})

				Promise.all([r1, ...r2])
					.then(() => {
						this.dialog.loading = false;
					})
					.catch(error => {
						this.dialog.loading = false;
						this.$toast.add({severity: "error", summary: "Error", detail: error, life: 6000});
					})
			},
			closeDialog() {
				this.dialog.visible = false;
				document.body.classList.remove("dialog-open");
			},
			displayTemplateVersion(template: any) {
                var templateVersion = template.version
				if (template.publishedDate == null) { 
					if (template.importVersion != null) {
						templateVersion += ":" + template.importVersion
					}
					else if (template.cloneVersion != null) {
						templateVersion += ":" + template.cloneVersion
					}
				}
				return templateVersion
			},
			// The versions listing is the editor's draft-set view; the same version string as
			// displayTemplateVersion, but for a set row instead of a template row.
			displaySetVersion(row: any) {
				if (row.importVersion != null) return row.version + ":" + row.importVersion;
				if (row.cloneVersion != null) return row.version + ":" + row.cloneVersion;
				return "" + row.version;
			},
			showCloneSingleDialog(template: any) {
				this.cloneSingleDialog.template = template;
				this.cloneSingleDialog.versions = [];
				this.cloneSingleDialog.visible = true;
				this.cloneSingleDialog.isLoading = true;
				templateApi.templateSetVersions(this.sheet.type, {sheetId: this.identifier})
					.then((response: any) => {
						this.cloneSingleDialog.versions = response.data.versions;
						this.cloneSingleDialog.isLoading = false;
					})
					.catch(error => {
						this.cloneSingleDialog.isLoading = false;
						this.$toast.add({severity: "error", summary: "Error", detail: error, life: 6000});
					})
			},
			hideCloneSingleDialog() {
				this.cloneSingleDialog.visible = false;
				this.cloneSingleDialog.template = null;
			},
			cloneTemplateSingle(row: any) {
				if (row.hasSheetDraft || this.cloneSingleDialog.isLoading) return;
				const template = this.cloneSingleDialog.template;
				this.$confirm.require({
					header: 'Confirmation',
					message: 'Clone version ' + template.version + ' of this sheet into draft version ' + this.displaySetVersion(row) + '?',
					icon: 'pi pi-exclamation-triangle',
					accept: () => {
						this.cloneSingleDialog.isLoading = true;
						templateApi.templateCloneSingle(template.identifier, row.version)
							.then((response: any) => {
								this.cloneSingleDialog.isLoading = false;
								this.hideCloneSingleDialog();
								this.$toast.add({severity: "success", summary: "Success", detail: response.message, life: 6000});
								this.find(1);
							})
							.catch(error => {
								this.cloneSingleDialog.isLoading = false;
								this.$toast.add({severity: "error", summary: "Error", detail: error, life: 6000});
							})
					}
				})
			},
			deleteTemplateSingle(template: any) {
				this.$confirm.require({
					header: 'Confirmation',
					message: 'Delete only this sheet\'s draft template of version ' + this.displayTemplateVersion(template) + '? Drafts of other sheets in this version are kept.',
					icon: 'pi pi-exclamation-triangle',
					accept: () => {
						this.isDeleting = true;
						templateApi.templateDeleteSingle(template.identifier)
							.then((response: any) => {
								store.getters.getCached.page = null;
								this.isDeleting = false;
								this.$toast.add({severity: "success", summary: "Success", detail: response.message, life: 6000});
								this.find(1);
							})
							.catch(error => {
								this.isDeleting = false;
								this.$toast.add({severity: "error", summary: "Error", detail: error, life: 6000});
							})
					}
				})
			},
			deleteTemplate(template: any) {
				this.$confirm.require({
					header: 'Confirmation',
					message: 'Are you sure you want to delete all draft templates of this version?',
					icon: 'pi pi-exclamation-triangle',
					accept: () => {
						this.isDeleting = true;
						template.sheet = { identifier: this.identifier };
						templateApi.templateDelete({template: template})
							.then((response: any) => {
								store.getters.getCached.page = null;
								this.isDeleting = false;
								this.$toast.add({severity: "success", summary: "Success", detail: response.message, life: 6000});
								this.find(1);
							})
							.catch(error => {
								this.isDeleting = false;
								this.$toast.add({severity: "error", summary: "Error", detail: error, life: 6000});
							})
					}
				})
			}
		},
		setup() {
			return { v$: useVuelidate() }
		},
		validations() {
			return {
				sheet : {
					code: {
						required
					},
					name: {
						required
					},
					sequence: {
						required
					},
					type: {
						required
					},
					isClosed: {
						required
					},
				}
			}
		}
	});
</script>
